module.exports = __webpack_public_path__ + "files/1058c182e38158fbcdc46e60fa0fa834.png";